import { MessageCentreFolderNameMap, MessageCentreNames } from '@ukpostbox/client-data';
import { MessageCentreStoreStateType } from '../../Types/MessageCentreStoreTypes';

export const defaultMessageCentreData: MessageCentreStoreStateType = {
	currentThreadId: undefined,
	folderName: MessageCentreFolderNameMap.all,
	folderMappedId: MessageCentreNames[MessageCentreFolderNameMap.all],
	showFilterModal: false,
	messageThreadOpen: false,
	messageUpdateStatus: { updating: false },
};
